import { Helmet } from "react-helmet-async";
import { articleSchema, type ArticleSchemaInput } from "./schema";

export default function ArticleSchema(props: ArticleSchemaInput) {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(articleSchema(props))}
      </script>
    </Helmet>
  );
}
